import * as React from "react";
import { FunctionComponent, useState, useEffect } from "react";
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input/input';
import { isValidPhoneNumber, formatPhoneNumber, isPossiblePhoneNumber } from "react-phone-number-input";
import { GeneralLiabilityClaimReport, ClaimType } from "../../../Models/Claim";
import FileDragAndDrop from "../../FileDragAndDrop";
import { FilesTable } from "../../FilesTable";

import ReactTooltip from 'react-tooltip';
import { ByteLimit, ValidateEmail } from "../../../Utils";
import { Collapse } from "react-bootstrap";
interface StepThreeProps {
    goBack: (step: number, claim: GeneralLiabilityClaimReport, validate: boolean) => void;
    claim: GeneralLiabilityClaimReport;
    showError: boolean;
}

export const StepThree: FunctionComponent<StepThreeProps> = ({ goBack, claim, showError }) => 
{
	//This is general liability step three
    const [shouldScroll, setShouldScroll] = useState<boolean>(true);
    const [width, setWidth] = useState<number>(window.innerWidth);
	const [occuranceType, setOccuranceType] = useState<string>(claim.occuranceType);
	const [propertyDescription, setPropertyDescription] = useState<string>(claim.propertyDescription);
	const [propertyOwnerName, setPropertyOwnerName] = useState<string>(claim.propertyOwnerName);
	const [propertyOwnerAddress, setPropertyOwnerAddress] = useState<string>(claim.propertyOwnerAddress);
	const [propertyOwnersPrimaryPhone, setPropertyOwnersPrimaryPhone] = useState<string>(claim.propertyOwnersPrimaryPhone);
	const [propertyOwnersAlternatePhone, setPropertyOwnersAlternatePhone] = useState<string>(claim.propertyOwnersAlternatePhone);
	const [propertyOwnersEmail, setPropertyOwnersEmail] = useState<string>(claim.propertyOwnersEmail);
	const [propertyDamageAmount, setPropertyDamageAmount] = useState<string>(claim.propertyDamageAmount);
	const [injuryDescription, setInjuryDescription] = useState<string>(claim.injuryDescription);
	const [injuredPersonsName, setInjuredPersonsName] = useState<string>(claim.injuredPersonsName);
	const [injuredPersonsAddress, setInjuredPersonsAddress] = useState<string>(claim.injuredPersonsAddress);
	const [injuredPersonsPrimaryPhone, setInjuredPersonsPrimaryPhone] = useState<string>(claim.injuredPersonsPrimaryPhone);
	const [injuredPersonsAlternatePhone, setInjuredPersonsAlternatePhone] = useState<string>(claim.injuredPersonsAlternatePhone);
	const [injuredPersonsEmail, setInjuredPersonsEmail] = useState<string>(claim.injuredPersonsEmail);


	useEffect(() => {
		if (shouldScroll) {
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
			setShouldScroll(false);
		}
	}, [shouldScroll])

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    
    function getLocalStorage(key: string) {
		return localStorage.getItem(key) || ""
	}

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    let isMobile: boolean = (width <= 768);

    return <div className="step-three">
    <div className="form-group">
        <label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="occurance-type">Occurance Type?<span className="red-ast">*</span></label>
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <select className="form-control" id="occurance-type" area-required aria-invalid={showError && occuranceType === ""} aria-describedby="occuranceTypeError" name="What type of occurance happened?" value={occuranceType} onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                setOccuranceType(e.target.value);
            }}>
				<option value="">Select...</option>
				<option value="Dog Bite Injury">Dog Bite Injury</option>
				<option value="Dog Bite Property Damage">Dog Bite Property Damage</option>
				<option value="Trip and Fall Injury">Trip and Fall Injury</option>
				<option value="Trip and Fall Property Damage">Trip and Fall Property Damage</option>
				<option value="Other Injury">Other Injury</option>
				<option value="Other Property Damage">Other Property Damage</option>
				<option value="Injury and Property Damage">Injury and Property Damage</option>
				<option value="Employment Practices">Employment Practices</option>
				<option value="Cyber">Cyber</option>
            </select>
            <p id="occuranceTypeError" className={showError && occuranceType === "" ? "error" : "error-hidden"}>This field is required</p>
        </div>
    </div>
	<Collapse in={occuranceType.includes("Property") && !occuranceType.includes("Injury")}>
		<div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="property-description">Describe Property:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="text" maxLength={55} id="property-description" placeholder="Broken fence" name="Describe the property" value={propertyDescription} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setPropertyDescription(e.target.value);
					}} />
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="property-owner-name">Property Owners Name:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="text" maxLength={55} id="property-owner-name" placeholder="John Smith" name="Name of the property owner" value={propertyOwnerName} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setPropertyOwnerName(e.target.value);
					}} />
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="property-owner-address">Property Owners Address:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="text" maxLength={55} id="property-owner-address" placeholder="123 Main Street" name="Address of the property" value={propertyOwnerAddress} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setPropertyOwnerAddress(e.target.value);
					}} />
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="owner-primary-phone">Property Owners Primary Phone Number:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<PhoneInput id="owner-primary-phone" aria-invalid={showError && (propertyOwnersPrimaryPhone !== "" && !isValidPhoneNumber(propertyOwnersPrimaryPhone))} aria-describedby="ownerPrimaryPhoneError" className="form-control" placeholder="(123)-456-7890" name="Property Owner Primary Phone" country="US" international={false} value={propertyOwnersPrimaryPhone} maxLength={14} onChange={(phone: string) => {
						if (!phone) phone = "";
						setPropertyOwnersPrimaryPhone(phone);
					}} />
					<p id="ownerPrimaryPhoneError" className={showError && (propertyOwnersPrimaryPhone !== "" && !isValidPhoneNumber(propertyOwnersPrimaryPhone)) ? "error" : "error-hidden"}>Please provide a valid phone number</p>
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="owner-alternate-phone">Property Owners Alternate Phone Number:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<PhoneInput id="owner-alternate-phone" aria-invalid={showError && (propertyOwnersAlternatePhone !== "" && !isValidPhoneNumber(propertyOwnersAlternatePhone))} aria-describedby="ownerAlternatePhoneError" className="form-control" placeholder="(123)-456-7890" name="Property Owner Alternate Phone" country="US" international={false} value={propertyOwnersAlternatePhone} maxLength={14} onChange={(phone: string) => {
						if (!phone) phone = "";
						setPropertyOwnersAlternatePhone(phone);
					}} />
					<p id="ownerAlternatePhoneError" className={showError && (propertyOwnersAlternatePhone !== "" && !isValidPhoneNumber(propertyOwnersAlternatePhone)) ? "error" : "error-hidden"}>Please provide a valid phone number</p>
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="property-owner-email">Property Owners Email:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="email" aria-invalid={showError && propertyOwnersEmail !== "" && !ValidateEmail(propertyOwnersEmail)} aria-describedby="ownerEmailError" id="property-owner-email" placeholder="jsmith@domain.com" name="Property owner's email" value={propertyOwnersEmail} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setPropertyOwnersEmail(e.target.value.toLocaleLowerCase());
					}} />
					<p id="ownerEmailError" className={showError && (propertyOwnersEmail !== "" && !ValidateEmail(propertyOwnersEmail)) ? "error" : "error-hidden"}>Please provide a valid email</p>
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="property-owner-estimation">Estimation Amount (if known):</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="text" id="property-owner-estimation" maxLength={10} placeholder="$ Amount or Unknown" name="Estimated amount of damage" value={propertyDamageAmount} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setPropertyDamageAmount(e.target.value);
					}} />
				</div>
			</div>
		</div>
	</Collapse>

	<Collapse in={occuranceType.includes("Employment")}>
		<div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="injury-description">Describe Claim:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="text" maxLength={55} id="claim-description" placeholder="Wrongful Termination" name="Description of the Claim" value={injuryDescription} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setInjuryDescription(e.target.value);
					}} />
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="injured-persons-name">Employee/Customers Name:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="text" maxLength={55} id="employee-name" placeholder="John Smith" name="Named of the employee/customer" value={injuredPersonsName} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setInjuredPersonsName(e.target.value);
					}} />
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="injured-persons-address">Employee/Customers Address:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="text" maxLength={55} id="employee-address" placeholder="123 Main Street" name="Address of the employee/customer" value={injuredPersonsAddress} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setInjuredPersonsAddress(e.target.value);
					}} />
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="injured-persons-primary-phone">Employee/Customers Primary Phone Number:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
						<PhoneInput id="employee-primary-phone" aria-invalid={showError && (injuredPersonsPrimaryPhone !== "" && !isValidPhoneNumber(injuredPersonsPrimaryPhone))} aria-describedby="injuredPersonsPrimaryPhoneError" className="form-control" placeholder="(123)-456-7890" name="Employee/Customers Primary Phone" country="US" international={false} value={injuredPersonsPrimaryPhone} maxLength={14} onChange={(phone: string) => {
						if (!phone) phone = "";
						setInjuredPersonsPrimaryPhone(phone);
					}} />
					<p id="injuredPersonsPrimaryPhoneError" className={showError && (injuredPersonsPrimaryPhone !== "" && !isValidPhoneNumber(injuredPersonsPrimaryPhone)) ? "error" : "error-hidden"}>Please provide a valid phone number</p>
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="injured-persons-alternate-phone">Employee/Customers Alternate Phone Number:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<PhoneInput id="employee-alternate-phone" aria-invalid={showError && (injuredPersonsAlternatePhone !== "" && !isValidPhoneNumber(injuredPersonsAlternatePhone))} aria-describedby="injuredPersonsAlternatePhoneError" className="form-control" placeholder="(123)-456-7890" name="Employee/Customers Alternate Phone" country="US" international={false} value={injuredPersonsAlternatePhone} maxLength={14} onChange={(phone: string) => {
						if (!phone) phone = "";
						setInjuredPersonsAlternatePhone(phone);
					}} />
					<p id="injuredPersonsAlternatePhoneError" className={showError && (injuredPersonsAlternatePhone !== "" && !isValidPhoneNumber(injuredPersonsAlternatePhone)) ? "error" : "error-hidden"}>Please provide a valid phone number</p>
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="injured-persons-email">Employee/Customers Email:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="email" aria-invalid={showError && propertyOwnersEmail !== "" && !ValidateEmail(injuredPersonsEmail)} aria-describedby="injuredPersonsEmailError" id="employees-email" placeholder="jsmith@domain.com" name="Employee/Customers Email" value={injuredPersonsEmail} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setInjuredPersonsEmail(e.target.value.toLocaleLowerCase());
					}} />
					<p id="injuredPersonsEmailError" className={showError && (injuredPersonsEmail !== "" && !ValidateEmail(injuredPersonsEmail)) ? "error" : "error-hidden"}>Please provide a valid email</p>
				</div>
			</div>
		</div>
	</Collapse>

	<Collapse in={occuranceType.includes("Injury") && !occuranceType.includes("Property")}>
		<div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="injury-description">Describe Injury:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="text" maxLength={55} id="injury-description" placeholder="Broken leg" name="Description of the injury" value={injuryDescription} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setInjuryDescription(e.target.value);
					}} />
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="injured-persons-name">Injured Persons Name:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="text" maxLength={55} id="injured-persons-name" placeholder="John Smith" name="Named of the injured" value={injuredPersonsName} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setInjuredPersonsName(e.target.value);
					}} />
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="injured-persons-address">Injured Persons Address:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="text" maxLength={55} id="injured-persons-address" placeholder="123 Main Street" name="Address of the injured" value={injuredPersonsAddress} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setInjuredPersonsAddress(e.target.value);
					}} />
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="injured-persons-primary-phone">Injured Persons Primary Phone Number:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
						<PhoneInput id="injured-persons-primary-phone" aria-invalid={showError && (injuredPersonsPrimaryPhone !== "" && !isValidPhoneNumber(injuredPersonsPrimaryPhone))} aria-describedby="injuredPersonsPrimaryPhoneError" className="form-control" placeholder="(123)-456-7890" name="Injured Persons Primary Phone" country="US" international={false} value={injuredPersonsPrimaryPhone} maxLength={14} onChange={(phone: string) => {
						if (!phone) phone = "";
						setInjuredPersonsPrimaryPhone(phone);
					}} />
					<p id="injuredPersonsPrimaryPhoneError" className={showError && (injuredPersonsPrimaryPhone !== "" && !isValidPhoneNumber(injuredPersonsPrimaryPhone)) ? "error" : "error-hidden"}>Please provide a valid phone number</p>
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="injured-persons-alternate-phone">Injured Persons Alternate Phone Number:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<PhoneInput id="injured-persons-alternate-phone" aria-invalid={showError && (injuredPersonsAlternatePhone !== "" && !isValidPhoneNumber(injuredPersonsAlternatePhone))} aria-describedby="injuredPersonsAlternatePhoneError" className="form-control" placeholder="(123)-456-7890" name="Injured Persons Alternate Phone" country="US" international={false} value={injuredPersonsAlternatePhone} maxLength={14} onChange={(phone: string) => {
						if (!phone) phone = "";
						setInjuredPersonsAlternatePhone(phone);
					}} />
					<p id="injuredPersonsAlternatePhoneError" className={showError && (injuredPersonsAlternatePhone !== "" && !isValidPhoneNumber(injuredPersonsAlternatePhone)) ? "error" : "error-hidden"}>Please provide a valid phone number</p>
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="injured-persons-email">Injured Persons Email:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="email" aria-invalid={showError && propertyOwnersEmail !== "" && !ValidateEmail(injuredPersonsEmail)} aria-describedby="injuredPersonsEmailError" id="injured-persons-email" placeholder="jsmith@domain.com" name="Injured persons's email" value={injuredPersonsEmail} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setInjuredPersonsEmail(e.target.value.toLocaleLowerCase());
					}} />
					<p id="injuredPersonsEmailError" className={showError && (injuredPersonsEmail !== "" && !ValidateEmail(injuredPersonsEmail)) ? "error" : "error-hidden"}>Please provide a valid email</p>
				</div>
			</div>
		</div>
	</Collapse>

	<Collapse in={occuranceType.includes("Injury") && occuranceType.includes("Property")}>
		<div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="both-property-description">Describe Property:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="text" maxLength={55} id="both-property-description" placeholder="Broken fence" name="Describe the property" value={propertyDescription} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setPropertyDescription(e.target.value);
					}} />
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="both-property-owner-name">Property Owners Name:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="text" maxLength={55} id="both-property-owner-name" placeholder="John Smith" name="Name of the property owner" value={propertyOwnerName} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setPropertyOwnerName(e.target.value);
					}} />
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="both-property-owner-address">Property Owners Address:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="text" maxLength={55} id="both-property-owner-address" placeholder="123 Main Street" name="Address of the property" value={propertyOwnerAddress} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setPropertyOwnerAddress(e.target.value);
					}} />
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="both-owner-primary-phone">Property Owners Primary Phone Number:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<PhoneInput id="both-owner-primary-phone" aria-invalid={showError && (propertyOwnersPrimaryPhone !== "" && !isValidPhoneNumber(propertyOwnersPrimaryPhone))} aria-describedby="bothOwnerPrimaryPhoneError" className="form-control" placeholder="(123)-456-7890" name="Property Owner Primary Phone" country="US" international={false} value={propertyOwnersPrimaryPhone} maxLength={14} onChange={(phone: string) => {
						if (!phone) phone = "";
						setPropertyOwnersPrimaryPhone(phone);
					}} />
					<p id="bothOwnerPrimaryPhoneError" className={showError && (propertyOwnersPrimaryPhone !== "" && !isValidPhoneNumber(propertyOwnersPrimaryPhone)) ? "error" : "error-hidden"}>Please provide a valid phone number</p>
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="both-owner-alternate-phone">Property Owners Alternate Phone Number:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<PhoneInput id="both-owner-alternate-phone" aria-invalid={showError && (propertyOwnersAlternatePhone !== "" && !isValidPhoneNumber(propertyOwnersAlternatePhone))} aria-describedby="bothOwnerAlternatePhoneError" className="form-control" placeholder="(123)-456-7890" name="Property Owner Alternate Phone" country="US" international={false} value={propertyOwnersAlternatePhone} maxLength={14} onChange={(phone: string) => {
						if (!phone) phone = "";
						setPropertyOwnersAlternatePhone(phone);
					}} />
					<p id="bothOwnerAlternatePhoneError" className={showError && (propertyOwnersAlternatePhone !== "" && !isValidPhoneNumber(propertyOwnersAlternatePhone)) ? "error" : "error-hidden"}>Please provide a valid phone number</p>
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="property-owner-email">Property Owners Email:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="email" aria-invalid={showError && propertyOwnersEmail !== "" && !ValidateEmail(propertyOwnersEmail)} aria-describedby="bothOwnerEmailError" id="property-owner-email" placeholder="jsmith@domain.com" name="Property owner's email" value={propertyOwnersEmail} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setPropertyOwnersEmail(e.target.value.toLocaleLowerCase());
					}} />
					<p id="bothOwnerEmailError" className={showError && (propertyOwnersEmail !== "" && !ValidateEmail(propertyOwnersEmail)) ? "error" : "error-hidden"}>Please provide a valid email</p>
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="property-owner-estimation">Estimation Amount (if known):</label>
					<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 margin-bottom">
					<input className="form-control" type="text" id="property-owner-estimation" maxLength={10} placeholder="$ Amount or Unknown" name="Estimated amount of damage" value={propertyDamageAmount} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setPropertyDamageAmount(e.target.value);
					}} />
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="both-injury-description">Describe Injury:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="text" maxLength={55} id="both-injury-description" placeholder="Broken leg" name="Description of the injury" value={injuryDescription} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setInjuryDescription(e.target.value);
					}} />
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="both-injured-persons-name">Injured Persons Name:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="text" maxLength={55} id="both-injured-persons-name" placeholder="John Smith" name="Named of the injured" value={injuredPersonsName} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setInjuredPersonsName(e.target.value);
					}} />
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="both-injured-persons-address">Injured Persons Address:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="text" maxLength={55} id="both-injured-persons-address" placeholder="123 Main Street" name="Address of the injured" value={injuredPersonsAddress} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setInjuredPersonsAddress(e.target.value);
					}} />
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="both-injured-persons-primary-phone">Injured Persons Primary Phone Number:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<PhoneInput id="both-injured-persons-primary-phone" aria-invalid={showError && (injuredPersonsPrimaryPhone !== "" && !isValidPhoneNumber(injuredPersonsPrimaryPhone))} aria-describedby="bothInjuredPersonsPrimaryPhoneError" className="form-control" placeholder="(123)-456-7890" name="Injured Persons Primary Phone" country="US" international={false} value={injuredPersonsPrimaryPhone} maxLength={14} onChange={(phone: string) => {
						if (!phone) phone = "";
						setInjuredPersonsPrimaryPhone(phone);
					}} />
					<p id="bothInjuredPersonsPrimaryPhoneError" className={showError && (injuredPersonsPrimaryPhone !== "" && !isValidPhoneNumber(injuredPersonsPrimaryPhone)) ? "error" : "error-hidden"}>Please provide a valid phone number</p>
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="both-injured-persons-alternate-phone">Injured Persons Alternate Phone Number:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<PhoneInput id="both-injured-persons-alternate-phone" aria-invalid={showError && (injuredPersonsAlternatePhone !== "" && !isValidPhoneNumber(injuredPersonsAlternatePhone))} aria-describedby="bothInjuredPersonsAlternatePhoneError" className="form-control" placeholder="(123)-456-7890" name="Injured Persons Alternate Phone" country="US" international={false} value={injuredPersonsAlternatePhone} maxLength={14} onChange={(phone: string) => {
						if (!phone) phone = "";
						setInjuredPersonsAlternatePhone(phone);
					}} />
					<p id="bothInjuredPersonsAlternatePhoneError" className={showError && (injuredPersonsPrimaryPhone !== "" && !isValidPhoneNumber(injuredPersonsPrimaryPhone)) ? "error" : "error-hidden"}>Please provide a valid phone number</p>
				</div>
			</div>
			<div className="form-group">
				<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="both-injured-persons-email">Injured Persons Email:</label>
				<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
					<input className="form-control" type="email" aria-invalid={showError && propertyOwnersEmail !== "" && !ValidateEmail(injuredPersonsEmail)} aria-describedby="bothInjuredPersonsEmailError" id="both-injured-persons-email" placeholder="jsmith@domain.com" name="Injured persons's email" value={injuredPersonsEmail} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setInjuredPersonsEmail(e.target.value.toLocaleLowerCase());
					}} />
					<p id="bothInjuredPersonsEmailError" className={showError && (injuredPersonsEmail !== "" && !ValidateEmail(injuredPersonsEmail)) ? "error" : "error-hidden"}>Please provide a valid email</p>
				</div>
			</div>
		</div>
	</Collapse>

    <div className="form-group button-group">
        <button className="btn btn-primary col-lg-6 col-sm-6 col-xs-6" type="button" onClick={() => { goToStep(3); }}><i className="fa fa-arrow-left" aria-hidden="true" />&nbsp;BACK</button>
        <button className="btn btn-primary col-lg-6 col-sm-6 col-xs-6" type="button" onClick={() => { goToStep(5, showError ? true : false);}}><i className="fa fa-arrow-right" aria-hidden="true" />&nbsp;NEXT</button>
    </div>
</div>;

    function updateClaim()
    {
		claim.occuranceType = occuranceType;
		claim.propertyDescription = propertyDescription;
		claim.propertyOwnerName = propertyOwnerName;
		claim.propertyOwnerAddress = propertyOwnerAddress;
		claim.propertyOwnersPrimaryPhone = propertyOwnersPrimaryPhone;
		claim.propertyOwnersAlternatePhone = propertyOwnersAlternatePhone;
		claim.propertyOwnersEmail = propertyOwnersEmail;
		claim.propertyDamageAmount = propertyDamageAmount;
		claim.injuryDescription = injuryDescription;
		claim.injuredPersonsName = injuredPersonsName;
		claim.injuredPersonsAddress = injuredPersonsAddress;
		claim.injuredPersonsPrimaryPhone = injuredPersonsPrimaryPhone;
		claim.injuredPersonsAlternatePhone = injuredPersonsAlternatePhone;
		claim.injuredPersonsEmail = injuredPersonsEmail;

        return claim;
    }

    function goToStep(step: number, validate:boolean = false)
    {
        goBack(step,updateClaim(),validate);
    }
}
